import * as Shapes from '../../components/shape/shapes'

export const ShapeList = {
  blob01: Shapes.Blob01,
  blob02: Shapes.Blob02,
  blob03: Shapes.Blob03,
  blob04: Shapes.Blob04,
  blob05: Shapes.Blob05,
  blob06: Shapes.Blob06,
  shadow01: Shapes.Shadow01,
  shadow02: Shapes.Shadow02,
  shadow03: Shapes.Shadow03,
  shadow04: Shapes.Shadow04,
  shadow05: Shapes.Shadow05,
  shadow06: Shapes.Shadow06,
}
